import React from 'react'
import Header from './Header'
import Home from './Home'

const Entry = () => {
  return (
    <div>
        <Header />
        <Home />
    </div>
  )
}

export default Entry